import React, { useEffect, useState } from 'react';
import { GoThumbsup, GoThumbsdown } from "react-icons/go"
import ChatPrompt from '../../ChatBox/ChatPrompt';
import IconButton from '../../common/iconButton';
import MoreOptions from './moreOptions';
import { Link, useParams } from 'react-router-dom';
import UploadedImagesDisplay from '../../Create/UploadedImagesDisplay';
import { useDispatch } from 'react-redux';
import { get_posts_reaction_activity_by_user } from '../../../redux/Thunks/discussionsThunk';
import { get_debates_reaction_activity_by_user } from '../../../redux/Thunks/debatesThunk';

const CommentImpression = ({ index, id, commentPoster, author_ID, username, comment_date,
    commentMedia, comment_text, upvote_count, downvote_count, replyComment, input_value,
    set_Input_Value, img, handleReplyChange, reply, replyPromptShow, edit_box,
    toggleReplyBox, edit_delete_div, showMoreActions,deleted, replyMedia, handleReplyFile,
    replyMediaUploadError, removeMediaFromReplyList, deleteComment, editComment, handleUpdate,
    cancelAction, reaction, toggle_Click }) => {

    const { discussion_id, project_id, debate_id } = useParams()




    const dispatch = useDispatch()
    const [reactionsPerComment, setReactionsPerComment] = useState()
    const [isClicked, setIsClicked] = useState([false, false])

    function getRxn(ID){
            dispatch(
            discussion_id ?
            get_posts_reaction_activity_by_user({
                user_id: author_ID,
                eid: ID
            })
            : debate_id ?
            get_debates_reaction_activity_by_user({
                user_id: author_ID,
                eid: ID
            })
            : project_id &&
            null
        )
        .then(({ payload }) => {
            setReactionsPerComment(payload)
        });
    }

    const handleLikeAndDislikeColor = (mode) => {
        if(mode === "up"){
            setIsClicked([!isClicked[0], !isClicked[1]])
        }else{
            setIsClicked([!isClicked[0], !isClicked[1]])
        }
        
    }


    useEffect(() => {
        getRxn(id)
    //eslint-disable-next-line
    }, []);



        const frame = (pictures) => {
            if(pictures.length === 1){
                return "h-[200px] w-[200px] md:h-[300px] md:w-[300px]"
            }else if(pictures.length === 2){
                return "h-[120px] w-[120px] md:h-[200px] md:w-[200px] lg:w-[300px]"
            }else if(pictures.length === 3){
                return "h-[120px] w-[120px] md:h-[200px] md:w-[200px] lg:w-[300px]"
            }else if(pictures.length === 4){
                return "h-[120px] w-[120px] md:h-[200px] md:w-[200px] lg:w-[300px]"
            }

        }

    return (
        <div
        className='flex flex-wrap mx-2 relative my-3'
        onClick={() => {
            if(edit_delete_div[index]){ //For closing the moreOptions div
                showMoreActions(index)
            }
            if(replyPromptShow[index]){ //For closing the reply input
                toggleReplyBox(index)
            }
             }}>

        <div className='flex px-3 w-full'>
            <div className='w-[50px] h-[50px] md:pt-4'>
                {deleted ?
                <div className='w-[50px] h-[50px] rounded-full bg-greenOnDarkMode' />
                :
                <img
                src={img}
                alt={`${username} profile`}
                className='w-full rounded-full'
                />
                }

            </div>

            <div className='px-2.5 lg:p-4 w-[90%] ml-2'>

                {deleted ?
                <p className='md:inline ml-0'>[deleted]</p>
                :
                 <div>
                <p className='md:inline ml-0'>{username}</p>
                <p className='inline m-1 my-2.5 sm:m-2.5 text-xs md:text-sm'>{comment_date}</p>
                </div>
                }
                {edit_box[index] ?
                    (<div className='mb-4'>
                        <textarea
                        className='w-full bg-transparent rounded
                            border-b border-gray-500 focus:outline-none'
                        value={input_value}
                        onChange={set_Input_Value}
                        autoFocus
                        >
                        </textarea>
                        <div className='flex justify-end'>
                            <IconButton
                                confirmClick={() => {
                                    handleUpdate(id, index)
                                }}
                                cancelEditing={cancelAction}
                                index={index}
                                backgroundColor="bg-gray-400"
                            />
                        </div>
                    </div>)
                    :
                    <div className='my-3'>
                    {deleted ?
                    <p>[this comment has been deleted.]</p>
                    :
                    <>
                    <p className='my-3'>
                   {comment_text}
                    </p>
                    <div className='flex justify-center flex-wrap'>
                    {commentMedia?.map((item, idx) => {
                        return (<div key={idx} className={` ${frame(commentMedia)} m-1`}>
                        {item.endsWith('mp4') ?
                        (
                        <video
                        className="w-full h-full object-cover"
                        controls>
                        <source src={item} type="video/mp4" />
                        Your browser does not support the video tag.
                        </video>
                        )
                        :
                        (
                        <Link to={item} target="_blank">
                            <img
                                src={item}
                                alt={`Media`}
                                className="w-full h-full object-cover"
                            />
                        </Link>
                        )
                        }
                        </div>)
                    })}
                    </div>
                    </>
                    }

                    </div>

                }



                <div className='flex w-full my-3 space-x-6'>
                    <p>{upvote_count}
                        <button
                        disabled={toggle_Click[index]}
                        onClick={e => {
                            handleLikeAndDislikeColor("up")
                            reaction(e)
                        }}
                        id="Thumbs_Up">
                        <GoThumbsup
                            id="Thumbs_Up"
                            className={`${toggle_Click[index] && "opacity-60 "}
                            mx-1 text-2xl inline
                             ${reactionsPerComment && 
                             (reactionsPerComment?.vote_type === "U" || isClicked[0]) && upvote_count > 0
                             ? "text-[#3C6E71]" : null}
                             `}
                        />
                        </button>
                    </p>



                    <p>{downvote_count}
                    <button
                        disabled={toggle_Click[index]}
                        onClick={e => {
                            handleLikeAndDislikeColor("down")
                            reaction(e)
                        }}
                        id="Thumbs_Down">
                        <GoThumbsdown
                            id="Thumbs_Down"
                            className={`mx-1 text-2xl inline ${toggle_Click[index] && "opacity-60"}
                               ${reactionsPerComment && 
                               (reactionsPerComment?.vote_type === "D" || isClicked[1]) && downvote_count > 0
                             ? "text-red-400" : null}
                             `}
                        />
                        </button>

                    </p>

                    <button
                        onClick={() => {
                            toggleReplyBox(index)
                        }}
                        className='cursor-pointer'>
                        Reply
                    </button>
                </div>

                {/* REPLY BOX TO TOGGLE: DESKTOP AND TABLET */}
                <div className='hidden md:block'>
                    {replyPromptShow[index] &&
                        <ChatPrompt
                            currentMode={true}
                            bgOnDark="bg-nightModeDark"
                            position="static"
                            placeholder="Post your reply"
                            submitPrompt={e => {
                                e.preventDefault()
                                replyComment(id, index)
                            }}
                            value={reply}
                            handleChange={handleReplyChange}
                            mediaPresent={replyMedia.length > 0 && true}
                            showFileBTn={true}
                            selectFile={handleReplyFile}
                            id="debateReplyUpload"
                        />}


                <p className='m-3 text-red-600 text-sm'>{replyMediaUploadError}</p>

                <div>
                <UploadedImagesDisplay media={replyMedia} removeMedia={removeMediaFromReplyList} />
                </div>
                </div>


            </div>

            </div>


            {/* REPLY BOX TO TOGGLE: MOBILE ONLY*/}
            <div className='block md:hidden w-full'>
                {replyPromptShow[index] &&
                    <ChatPrompt
                        currentMode={true}
                        bgOnDark="bg-nightModeDark"
                        position="static"
                        placeholder="Post your reply"
                        submitPrompt={e => {
                            e.preventDefault()
                            replyComment(id, index)
                        }}
                        value={reply}
                        handleChange={handleReplyChange}
                        mediaPresent={replyMedia.length > 0 && true}
                            showFileBTn={true}
                            selectFile={handleReplyFile}
                            id="debateReplyUpload"
                        />}


                <p className='m-3 text-red-600 text-sm'>{replyMediaUploadError}</p>

                <div>
                <UploadedImagesDisplay media={replyMedia} removeMedia={removeMediaFromReplyList} />
                </div>
            </div>


            {/* SHOW/HIDE DELETE OR EDIT DIV */}
            {!deleted && (
                <>
                {commentPoster === author_ID &&
                <MoreOptions
                    id={id}
                    show_more_actions={showMoreActions}
                    index={index}
                    editDelete={edit_delete_div}
                    edit_comment={editComment}
                    delete_comment={deleteComment}
                />
            }
                </>
            )}




        </div>
    );
}

export default CommentImpression;
